import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const VariantSection = ({ variants, attributes, onAddVariant }) => {
  const { t } = useTranslation();
  const [newVariant, setNewVariant] = useState({
    quantity: '',
    values: []
  });

  const [selectedValues, setSelectedValues] = useState({});

  const handleAddVariant = () => {
    if (newVariant.quantity && Object.values(selectedValues).length === attributes.length) {
      onAddVariant({
        ...newVariant,
        values: Object.values(selectedValues)
      });
      setNewVariant({
        quantity: '',
        values: []
      });
      setSelectedValues({});
    }
  };

  const handleValueSelect = (attrIndex, value) => {
    setSelectedValues(prev => ({
      ...prev,
      [attrIndex]: value
    }));
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">{t('variants_title')}</h2>
      
      {attributes.length === 0 ? (
        <p className="text-gray-500">{t('add_attributes_first')}</p>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">{t('quantity_label')}</label>
              <input
                type="number"
                value={newVariant.quantity}
                onChange={(e) => setNewVariant(prev => ({ ...prev, quantity: e.target.value }))}
                className="w-full px-3 py-2 border rounded"
              />
            </div>
            
            {attributes.map((attr, attrIndex) => (
              <div key={attrIndex}>
                <label className="block text-sm font-medium mb-1">
                  {attr.name.en} / {attr.name.ar}
                </label>
                <select
                  value={selectedValues[attrIndex] || ''}
                  onChange={(e) => handleValueSelect(attrIndex, e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                >
                  <option value="">{t('select_value')}</option>
                  {attr.values.map((value, valueIndex) => (
                    <option key={valueIndex} value={value.en}>
                      {value.en} / {value.ar}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
          
          <button
            type="button"
            onClick={handleAddVariant}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={!newVariant.quantity || Object.values(selectedValues).length !== attributes.length}
          >
            Add Variant
          </button>
        </div>
      )}

      {variants.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-2">{t('added_variants_title')}</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">{t('values_en_ar')}</th>
                  <th className="py-2 px-4 border-b">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {variants.map((variant, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 border-b">
                      {variant.values.map((value, i) => (
                        <div key={i}>{value}</div>
                      ))}
                    </td>
                    <td className="py-2 px-4 border-b text-center">{variant.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariantSection;
